import client from "./client"

class auth {
  sendQuery (data: any) {
    return client.withAuth().post('/contact-uses', null, data)
  }
}

export default new auth()